<template>
    <div class="s2w-auto-update-selector-container">
        <div class="s2w-auto-update-label">
            {{ $t('BaseSaveToWorkspace.AutoUpdate.otherSettingLabel') }}
        </div>
        <div
            class="s2w-auto-update"
        >
            <div
                class="s2w-auto-update-switch"
                :class="{ enable }"
                @click="toggleAutoUpdate()"
            />
            <div class="s2w-auto-update-desc">
                <span>{{ AutoUpdateLabel }}</span>
            </div>
            <div
                class="s2w-auto-update-info"
                :aria-label="AutoUpdateLabelTip"
                data-balloon-pos="up"
                data-balloon-white
            >
                <PtIcon
                    icon="SolidInfo"
                    style="font-size: 24px;"
                />
            </div>
            <div class="s2w-auto-update-query-container">
                <div
                    class="s2w-auto-update-query-link"
                    @click="showQueryPopper = !showQueryPopper"
                >
                    {{ $t('BaseSaveToWorkspace.AutoUpdate.viewQuery') }}
                </div>
                <div
                    v-if="showQueryPopper"
                    class="s2w-auto-update-query-popper"
                    @mousedown.stop
                >
                    <div class="s2w-auto-update-query-content">
                        {{ autoUpdate.q }}
                    </div>
                    <div
                        v-if="autoUpdate.efq"
                        class="s2w-auto-update-query-content s2w-efq"
                    >
                        {{ $t('BaseSaveToWorkspace.DrugAutoUpdate.refine') }}: {{ autoUpdate.efq }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/info.svg';

export default {
    name: 'DrugAutoUpdateSelector',
    components: {
        PtIcon,
    },
    inject: ['service'],
    data() {
        return {
            showQueryPopper: false,
        };
    },

    computed: {
        enable() {
            return this.service.autoUpdate.enable
        },
        autoUpdate() {
            return this.service.autoUpdate;
        },
        AutoUpdateLabel() {
            return this.$t('BaseSaveToWorkspace.DrugAutoUpdate.label');
        },
        AutoUpdateLabelTip() {
            return this.$t('BaseSaveToWorkspace.DrugAutoUpdate.tip');
        },
    },
    created() {
        this.closeQueryPopper = () => {
            this.showQueryPopper = false;
        };
        document.addEventListener('mousedown', this.closeQueryPopper);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.closeQueryPopper);
    },
    methods: {
        toggleAutoUpdate() {
            this.service.toggleAutoUpdate(!this.enable);
            return true;
        },
    },
};
</script>
